import './CoralSocialCards.scss'

import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { mapCoralWebSocialCards } from '@websrc/DataMappers/mapSpot'
import React, { FC } from 'react'

import IconProvider from '../../../coral-library/icons/IconProvider'
import Logo from './assets/logo.png'

type CoralSocialCardsProps = ReturnType<typeof mapCoralWebSocialCards>

export const CoralSocialCards: FC<CoralSocialCardsProps> = (props) => {
  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-social-cards'}>
        <CoralHeading header={props.header} />
        <div className={'coral-social-cards__container'}>
          <CoralCardsSlider forceRow={true}>
            {props.socialVideos &&
              props.socialVideos.length > 0 &&
              props.socialVideos.map((socialPost, id) => (
                <a
                  className={'coral-social-cards__card'}
                  href={socialPost.link}
                  key={id}
                  rel={'noopener noreferrer'}
                  target={'_blank'}
                >
                  <video
                    autoPlay={false}
                    className={'coral-social-cards__video'}
                    loop={true}
                    muted={true}
                    onMouseEnter={(e) => e.currentTarget.play()}
                    onMouseLeave={(e) => {
                      e.currentTarget.pause()
                      e.currentTarget.currentTime = 0
                    }}
                    playsInline={true}
                    src={
                      socialPost.asset?.video && 'url' in socialPost.asset.video
                        ? socialPost.asset.video.url
                        : undefined
                    }
                  />
                  <div className={'coral-social-cards__card-info'}>
                    <div className={'coral-social-cards__card-account'}>
                      <div className={'coral-social-cards__card-account-logo'}>
                        <img role={'button'} src={Logo} tabIndex={0} />
                      </div>
                      <div className={'coral-social-cards__card-account-data-container'}>
                        <div className={'coral-social-cards__card-account-name-container'}>
                          <div className={'coral-social-cards__card-account-name'}>
                            legoeducation
                          </div>
                          <div className={'coral-social-cards__card-account-tick-icon'}>
                            <IconProvider name={'verified'} size={16} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={'coral-social-cards__card-info-instagram'}>
                      <IconProvider name={'instagram'} size={35} />
                    </div>
                  </div>
                </a>
              ))}
          </CoralCardsSlider>
        </div>
      </div>
    </div>
  )
}
